// import * as React from 'react';
import Error from './error';

export default function NotFound() {
	return (
		<Error
			errorCode="404"
			errorName="PAGE NOT FOUND"
			description="The page you are looking for might have been moved, removed, renamed or never existed."
		/>
	);
}